<template>
  <section class="mc-rec-section">
    <h2 class="mc-rec-section__title">Funil de conversão do período</h2>
    <p class="mc-rec-section__desc">Visualize onde há maior perda entre envio, leitura, clique e compra.</p>

    <div v-if="!steps || !steps.length" class="mc-rec-surface p-4 text-center text-muted">
      Sem dados de funil para o período.
    </div>
    <div v-else class="mc-rec-surface p-3 p-md-4">
      <div class="mc-rec-funnel">
        <div v-for="(step, i) in steps" :key="step.key" class="mc-rec-funnel__step">
          <div class="mc-rec-funnel__step-value">{{ formatarNum(step.value) }}</div>
          <div class="mc-rec-funnel__step-label">{{ step.label }}</div>
          <div v-if="step.rateFromPrev != null" class="mc-rec-funnel__rate">{{ step.rateFromPrev }}% da etapa anterior</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'RecommendationConversionFunnel',
  props: {
    steps: { type: Array, default: () => [] },
  },
  methods: {
    formatarNum(v) {
      if (v == null) return '—'
      return Number(v).toLocaleString('pt-BR')
    },
  },
}
</script>
